import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Redirect ThoughtSpot email links to the canonical AI highlight deep link.
 *
 * Trend analysis emails link to `/dashboard/insight/{id}` using ThoughtSpot's
 * native path segment. The app serves highlights at `/dashboard/ai-highlight/{id}`.
 */
export const Route = createFileRoute('/dashboard/_deep-links/insight/$object_id')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/ai-highlight/$object_id',
      params: { object_id: params.object_id },
    });
  },
  component: () => null,
});
